import { Reducer } from 'redux';
import { ACTION } from './action-types';
import * as actions from './action-types';
import { GroupByFieldState } from './types-store';

export const INITIAL_STATE: GroupByFieldState = {
  fetching: false,
  initialized: false,
  defaultGroupByFields: [],
  additionalGroupByFields: [],
  sortOrderTypes: [],
  selectionTypeInformation: {}
};

export const groupByReducers: { [indexer: string]: Reducer<GroupByFieldState> } = {
  [ACTION.CLEAR_GROUP_BY_STATE]: (state: GroupByFieldState,
    action: actions.ClearGroupByState
  ): GroupByFieldState => {
    return {
      ...state,
      ...INITIAL_STATE
    };
  },
  [ACTION.REQUEST_GROUP_BY_DEFAULT_FIELDS]: (state: GroupByFieldState,
    action: actions.RequestGroupByDefaultFields
  ): GroupByFieldState => {
    return {
      ...state,
      fetching: true
    };
  },
  [ACTION.RESPONSE_GROUP_BY_DEFAULT_FIELDS]: (state: GroupByFieldState,
    action: actions.ResponseGroupByDefaultFields
  ): GroupByFieldState => {
    return {
      ...state,
      fetching: false,
      initialized: true,
      defaultGroupByFields: action.options
    };
  },
  [ACTION.UPDATE_DEFAULT_GROUP_BY_FIELDS]: (state: GroupByFieldState,
    action: actions.UpdateGroupByDefaultFields
  ): GroupByFieldState => {
    return {
      ...state,
      defaultGroupByFields: action.options
    };
  },
  [ACTION.REQUEST_GROUP_BY_SORT_ORDER_TYPE]: (state: GroupByFieldState,
    action: actions.RequestGroupBySortOrderType
  ): GroupByFieldState => {
    return state;
  },
  [ACTION.RESPONSE_GROUP_BY_SORT_ORDER_TYPE]: (state: GroupByFieldState,
    action: actions.ResponseGroupBySortOrderType
  ): GroupByFieldState => {
    return {
      ...state,
      sortOrderTypes: action.options
    };
  },
  [ACTION.RESPONSE_GROUP_BY_FIELDS]: (state: GroupByFieldState,
    action: actions.ResponseGroupByFields
  ): GroupByFieldState => {
    return {
      ...state,
      additionalGroupByFields: action.options
    };
  },
  [ACTION.REQUEST_GROUP_BY_SELECTION_TYPES]: (state: GroupByFieldState,
    action: actions.RequestGroupBySelectionTypes
  ): GroupByFieldState => {
    return {
      ...state,
      fetching: true,
      selectionTypeInformation: {
        ...state.selectionTypeInformation,
        [action.selectionFieldId]: {
          showMissingValues: false,
          selectionTypes: []
        }
      }
    };
  },
  [ACTION.RESPONSE_GROUP_BY_SELECTION_TYPES]: (state: GroupByFieldState,
    action: actions.ResponseGroupBySelectionTypes
  ): GroupByFieldState => {

    return {
      ...state,
      fetching: false,
      selectionTypeInformation: {
        ...state.selectionTypeInformation,
        [action.selectionFieldId]: {
          showMissingValues: action.showMissingValues,
          selectionTypes: action.selectionTypes
        }
      }
    };
  }
};

export const groupByReducer = (state: GroupByFieldState = INITIAL_STATE, action: any) => {
  const r = groupByReducers[action.type];
  return (r && r(state, action)) || state;
};
